import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import ThemeToggle from "./ThemeToggle";

const LINKS = [
  { to: "/definition-sculpteur-contemporain", label: "Définition", testId: "nav-definition-link" },
  { to: "/courants-et-mouvements", label: "Courants", testId: "nav-courants-link" },
  { to: "/materiaux-et-techniques", label: "Matériaux", testId: "nav-materiaux-link" },
  { to: "/lexique-sculpture", label: "Lexique", testId: "nav-lexique-link" },
  { to: "/guide-achat-direct-artiste", label: "Guide d'achat", testId: "nav-guide-link" },
  { to: "/partenaires-metiers-d-art", label: "Partenaires", testId: "nav-partenaires-link" },
  { to: "/faq", label: "FAQ", testId: "nav-faq-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `link-underline text-[13px] tracking-wide transition-colors duration-300 ${
      isActive ? "text-bronze" : "text-ink/80 hover:text-ink"
    }`;

  return (
    <header
      data-testid="site-navbar"
      className="fixed inset-x-0 top-0 z-50 border-b border-ink/10 bg-paper/85 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <Link
          to="/"
          data-testid="nav-home-logo"
          className="font-serif text-xl leading-none tracking-tight sm:text-2xl"
          onClick={() => setOpen(false)}
        >
          Sculpteur <em className="text-bronze">français</em>
          <span className="ml-2 align-middle font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">
            référence<span className="font-bold text-ink">s</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Navigation principale">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={l.testId} className={linkClass}>
              {l.label}
            </NavLink>
          ))}
          <NavLink to="/contact" data-testid="nav-contact-link" className={linkClass}>
            Contact
          </NavLink>
          <ThemeToggle />
        </nav>

        <div className="flex items-center gap-3 lg:hidden">
          <ThemeToggle />
          <button
            data-testid="nav-mobile-toggle"
            className="text-ink"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="border-t border-ink/10 bg-paper px-6 py-6 lg:hidden"
          aria-label="Navigation mobile"
        >
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`${l.testId}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-serif text-2xl ${isActive ? "text-bronze" : "text-ink"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <NavLink
              to="/contact"
              data-testid="nav-contact-link-mobile"
              onClick={() => setOpen(false)}
              className="font-serif text-2xl text-ink"
            >
              Contact
            </NavLink>
          </div>
        </nav>
      )}
    </header>
  );
}
